import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ErrorState {
  error: {
    title: string;
    message: string;
    shouldLogout?: boolean;
    shouldGoBack?: boolean;
  } | null;
}
export const initialState: ErrorState = {
  error: null,
};
const ErrorSlice = createSlice({
  name: "error",
  initialState,
  reducers: {
    setError: (state, action: PayloadAction<ErrorState>) => {
      return {
        ...state,
        error: action.payload.error,
      };
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const { setError, clearError } = ErrorSlice.actions;
export default ErrorSlice.reducer;
